import { Row, Col, FormGroup, Label, Input, Button, Collapse } from 'reactstrap';

import { Trans } from "react-i18next";

import validator from "validator";

const MainForm = ({ shiftForm, setShiftForm, type, action, t }) => {

    const timeValidate = (_time, can_null = true) => {
        if (can_null & !_time) {
            return true
        }
        else if (!/^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(_time)) {
            return false
        }
        else
            return true;
    }

    const validateForm = (shiftForm) => {

        const _errors = [];

        const { name, time_from, time_to, date_from, date_to, time_from2, time_to2, permanent } = shiftForm;

        if (permanent){
            setShiftForm((old) =>({ ...old, date_from: null, date_to: null,}))
        }

        if (name == "" || name == null) {
            _errors.push(t("Invalid name"))
        }

        if (!timeValidate(time_from, false)) {
            _errors.push(t("Invalid time from"))
        }

        if (!timeValidate(time_to, false)) {
            _errors.push(t("Invalid time to"))
        }

        if (!timeValidate(time_from2, true)) {
            _errors.push(t("Invalid time from (secondary)"))
        }

        if (!timeValidate(time_to2, true)) {
            _errors.push(t("Invalid time to (secondary)"))
        }

        if (!permanent && validator.isDate(date_from) === false) {
            _errors.push(t("Invalid Date from"))
        }

        if (!permanent && validator.isDate(date_to) === false) {
            _errors.push(t("Invalid Date to"))
        }

        if (time_from2 & !time_to2) {
            _errors.push(t("time to (secondary) can't be empty"))
        }
        if (time_to2 & !time_from2) {
            _errors.push(t("time from (secondary) can't be empty"))
        }
        return _errors;
    }
    return (
        <>
            <Row>
                <Col className="col-md-4 col-xs-12 mb-3">
                    <FormGroup>
                        <Label htmlFor="shiftname"><Trans>Shift Name</Trans></Label>
                        <Input type="text"
                            name="shiftname"
                            id="shiftname"
                            placeholder="Name"
                            value={shiftForm.name || ""}
                            onChange={(e) => setShiftForm({ ...shiftForm, name: e.target.value })} />
                    </FormGroup>
                </Col>

                <Col className="col-md-4 col-sm-12">
                    <FormGroup>
                        <Label htmlFor="type"><Trans>Time from *</Trans></Label>
                        <Input
                            type="text"
                            name="addTimefrom"
                            id="addTimefrom"
                            placeholder="e.g. 8:00"
                            value={shiftForm.time_from || ""}
                            onChange={(e) => setShiftForm({ ...shiftForm, time_from: e.target.value })}
                        />
                        <p style={{ fontSize: '9px' }}><Trans>Timing is 24 hours</Trans></p>
                    </FormGroup>
                </Col>

                <Col className="col-md-4 col-sm-12">
                    <FormGroup>
                        <Label htmlFor="StartingDate"><Trans>Time to *</Trans></Label>
                        <Input
                            type="text"
                            name="addTimeto"
                            id="addTimeto"
                            placeholder="e.g. 17:00"
                            value={shiftForm.time_to || ""}
                            onChange={(e) => setShiftForm({ ...shiftForm, time_to: e.target.value })}
                        ></Input>
                        <p style={{ fontSize: '9px' }}><Trans>Timing is 24 hours</Trans></p>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col className="col-md-4 col-sm-12"></Col>
                <Col className="col-md-4 col-sm-12">
                    <FormGroup>
                        <Label htmlFor="type"><Trans>Time from (Secondary)</Trans></Label>
                        <Input
                            type="text"
                            name="addTimefrom"
                            id="addTimefrom"
                            placeholder="e.g. 8:00"
                            value={shiftForm.time_from2 || ''}
                            onChange={(e) => setShiftForm({ ...shiftForm, time_from2: e.target.value })}
                        />
                        <p style={{ fontSize: '9px' }}><Trans>Timing is 24 hours</Trans></p>
                    </FormGroup>
                </Col>

                <Col className="col-md-4 col-sm-12">
                    <FormGroup>
                        <Label htmlFor="StartingDate"><Trans>Time to (Secondary)</Trans></Label>
                        <Input
                            type="text"
                            name="addTimeto"
                            id="addTimeto"
                            placeholder="e.g. 17:00"
                            value={shiftForm.time_to2 || ''}
                            onChange={(e) => setShiftForm({ ...shiftForm, time_to2: e.target.value })}
                        ></Input>
                        <p style={{ fontSize: '9px' }}><Trans>Timing is 24 hours</Trans></p>
                    </FormGroup>
                </Col>
            </Row> 
            <FormGroup check >
                <Input name="permanent" type="checkbox" checked={shiftForm.permanent} onChange={(e) => setShiftForm({ ...shiftForm, permanent: !shiftForm.permanent })} />
                <Label check htmlFor="permanent"><Trans>Permanent</Trans></Label>
            </FormGroup>
            <Collapse isOpen={!shiftForm.permanent} >
                <Row>
                    <Col className="col-md mt-3">
                        <FormGroup>
                            <Label htmlFor="selectDatefrom"><Trans>Date from</Trans></Label>
                            <Input
                                type="date"
                                name="selectDatefrom"
                                id="selectDatefrom"
                                placeholder="Type here"
                                value={shiftForm.date_from || ""}
                                onChange={(e) => setShiftForm({ ...shiftForm, date_from: e.target.value })}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col className="col-md mt-3">
                        <FormGroup>
                            <Label htmlFor="selectDateto"><Trans>Date to</Trans></Label>
                            <Input
                                type="date"
                                name="selectDateto"
                                id="selectDateto"
                                placeholder="Type here"
                                value={shiftForm.date_to || ""}
                                onChange={(e) => setShiftForm({ ...shiftForm, date_to: e.target.value })}
                            ></Input>
                        </FormGroup>
                    </Col>
                </Row>
            </Collapse>
            <div className="d-flex justify-content-end mt-4">
                <Button
                    style={{ marginBottom: "10px" }}
                    color="success"
                    className="btn"
                    type="submit"
                    onClick={() => { action(validateForm, shiftForm) }}>
                    <Trans>{type}</Trans>
                </Button>
            </div>
        </>
    )
}

export default MainForm